<template>
  <div class="home" ref="container">
    <HeadVue></HeadVue>
    <section class="banner" style="margin-top: 60px; height: 500px">
      <Carousel style="height: 500px" :items="carouselItems" :interval="4000">
          <div class="banner-inner1 carousel-item">
            <div>
              <h1 class="banner-inner-title">构建自进化工业智能体</h1>
              <p class="banner-inner-desc">全力打造会学习、能进化的工业 <span style="margin-left: 10px;margin-right: 10px">“智数”</span> 体系，领航工业产业超速前行！</p>
            </div>
            <div style="margin-left: 110px;margin-bottom: 40px">
              <img :src="require('./assets/img/inner-left.png')" alt="工业智能体示意图" class="banner-img">
            </div>
          </div>
          <div class="banner-inner2 carousel-item">
            <div style="margin-top: 35px">
              <h1 class="banner-inner-title">解锁工业新生密码</h1>
              <p class="banner-inner-desc">AI 赋能产业升级，激发全链条、全环节、全流程的精准洞察与智能感知新效能！</p>
            </div>
            <div style="margin-left: 35px;margin-bottom: 40px; margin-top: 35px">
              <img :src="require('./assets/img/inner-left2.png')" alt="工业智能体示意图" class="banner-img">
            </div>
          </div>
          <div class="banner-inner3 carousel-item">
            <div>
              <h1 class="banner-inner-title">开启理想工业新征程</h1>
              <p class="banner-inner-desc">AI 无缝对接生产运营各领域，擘画未来企业崭新时代！</p>
            </div>
            <div style="margin-left: 216px;margin-bottom: 40px">
              <img :src="require('./assets/img/inner-left3.png')" alt="工业智能体示意图" class="banner-img">
            </div>
          </div>
      </Carousel>

    </section>
    <section class="section">
      <div style="display: flex;flex-direction:column;align-items: center;margin-bottom: 98px">
          <h2 class="section-title">塑造 “1 核 + 2 翼 + N 点” 的智慧工业生态体</h2>
          <span class="section-desc">用智能科技改变世界，让AI触手可及</span>
      </div>
      <div class="container">
        <div class="architecture-diagram">
          <div class="diagram-left-top">
            <span class="diagram-title">明晟云</span>
            <div class="line"></div>
          </div>
          <div class="diagram-left-bottom">
            <span class="diagram-title" style="margin-right: 20px">明晟研究院</span>
            <div class="line"></div>
          </div>
          <div class="diagram-right-bottom">
            <span class="diagram-title" style="margin-left: 40px">明晟工业数字化平台</span>
            <div class="line"></div>
          </div>
          <div class="diagram-left" style="width: 150px">
            <div style="margin-bottom: 165px;display: flex">
              <div style="margin-top: -30px">
                <img :src="require('./assets/img/diagram4.png')" alt="明晟云">
              </div>
            </div>
            <div>
              <img :src="require('./assets/img/diagram2.png')" alt="明晟研究院">
            </div>
          </div>
          <div class="diagram-center">
            <div>
              <img :src="require('./assets/img/diagram1.png')" alt="AI大模型">
            </div>
            <div style="font-size: 32px;color: #333333;font-weight: bold;margin-top: 30px">大模型</div>
          </div>
          <div class="diagram-right" style="width: 150px">
            <div style="position: relative">
              <img  :src="require('./assets/img/diagram3.png')" alt="明晟工业数字化平台" style="position: absolute;top: -125px;right: -60px">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div style="display: flex;flex-direction:column;align-items: center;">
          <h2 class="section-title">工业企业数智化难题</h2>
          <p class="section-desc">终端需求快速迭代，开发资源不均衡问题困扰开发者和企业客户</p>
      </div>
      <div class="container">

        <div class="features-grid">
          <div class="features-grid-left">
            <div class="feature-box">
              <h3>越来越复杂的应用场景</h3>
              <p>面对日益增长的多元化、多场景业务需求也在驱使制造企业不断部署新的资源</p>
            </div>
            <div class="feature-box">
              <h3>不断变化的市场需求</h3>
              <p>最终用户的需求在快速变化且存在不确定性，并随时发起的需求和响应反馈</p>
            </div>
            <div class="feature-box">
              <h3>项目交付遇到各种问题</h3>
              <p>程序员抽象能力弱，对业务知识缺乏有效积累和传承、无法满足定制化需求，导致交付周期漫长</p>
            </div>
            <div class="feature-box">
              <h3>新技术不断涌现</h3>
              <p>开发人员面对技术的的推陈出新，缺少时间培训适应周期较长</p>
            </div>
          </div>
          <div style="margin-left: 40px;margin-right: 40px;margin-top: 130px">
            <img :src="require('./assets/img/features1.png')">
          </div>
          <div class="features-grid-right">
            <div class="feature-box">
              <h3>企业内外部协同重构</h3>
              <p>面对日益增长的多元化、多场景业务需求也在驱使制造企业不断部署新的资源</p>
            </div>
            <div class="feature-box">
              <h3>线上/线下融合闭环</h3>
              <p>不同企业的传统业务与数字化路径不尽相同，而构建自我生态，在产业链上下游不同节点的企业也会有不同理解</p>
            </div>
            <div class="feature-box">
              <h3>合规、高效数字系统</h3>
              <p>随着全球疫情新常态、IT国产化趋势加剧，符合企业、国家、多区域安全标准和IT规范的要求，成为企业选择数字化服务时重要的指导要素</p>
            </div>
            <div class="feature-box">
              <h3>数据能力</h3>
              <p>对于数据的筛选、归类、详细刻画成为企业对数据应用的新开始，因此对数据的权属+触点满足+对应产品的“千人前面”应用，成为企业解读新“流量效应”的本质</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div style="display: flex;flex-direction:column;align-items: center;">
        <h2 class="section-title">利用垂直大模型实现知识资产和模型的结合</h2>
      </div>
      <div class="container">
        <div class="data-platform">
          <div class="platform-features" style="display: flex;justify-content: center;align-items: center">
            <div class="platform-feature" style="display: flex;align-items: center; justify-content: center;padding-bottom: 30px">
              <div>
                <img :src="require('./assets/img/platform1.png')">
                <h3 style="font-size: 36px;color: #181F5C;font-weight: 700;margin-top: 20px">垂直大模型</h3>
              </div>

              <div style="margin-left: 50px">
                <img :src="require('./assets/img/platform2.png')">
              </div>
            </div>
            <div class="platform-feature">
              <img :src="require('./assets/img/platform3.png')">
            </div>
            <div class="platform-feature">
              <div style="display: flex;margin-bottom: 30px">
                <div style="margin-right: 20px">
                  <img :src="require('./assets/img/platform5.png')">
                </div>
                <h3 class="platform-right-title">内容生成，降本</h3>
              </div>
              <div style="display: flex;margin-bottom: 30px">
                <div style="margin-right: 20px">
                  <img :src="require('./assets/img/platform5.png')">
                </div>
                <h3 class="platform-right-title">数字员工，增效</h3>
              </div>
              <div style="display: flex;margin-bottom: 30px">
                <div style="margin-right: 20px">
                  <img :src="require('./assets/img/platform5.png')">
                </div>
                <h3 class="platform-right-title">辅助决策，提质</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div style="display: flex;flex-direction:column;align-items: center;">
        <h2 class="section-title">用低代码平台助工业企业填补数字化最后一公里沟壑</h2>
      </div>
      <div class="container">
        <div style="display: flex; justify-content: center;align-items: center">
          <div>
            <div  style="display: flex;align-items: center;justify-content:space-between;margin-bottom: 30px">
              <div class="step-content" style="text-align: left">
                <h4>提高生产运营智能化水平</h4>
                <div>
                  <p>推动跨企业集成互联与智能运营建设智能现场</p>
                </div>
              </div>
              <div>
                <div class="step-number" style="display: flex; justify-content: center;align-items: center">
                  <h4>开发效率 <br/> 提升3-10倍</h4>
                  <img :src="require('./assets/img/solution1.png')">
                </div>
              </div>

            </div>
            <div style="display: flex;align-items: center;justify-content:space-between;margin-bottom: 30px">
              <div  class="step-content"  style="text-align: left">
                <h4>提高用户服务敏捷化水平</h4>
                <div>
                  <p>● 建设数字营销网络建设敏捷响应服务体系</p>
                  <p>● 探索平台化、集成化、场景化增值服务</p>
                </div>
              </div>
              <div>
                <div class="step-number" style="display: flex; justify-content: center;align-items: center">
                  <h4>开发工作<br/>  提高10-50%</h4>
                  <img :src="require('./assets/img/solution1.png')">
                </div>
              </div>
            </div>
            <div   style="display: flex;align-items: center;justify-content:space-between;margin-bottom: 30px">
              <div class="step-content" style="text-align: left">
                <h4>提高生产运营智能化水平</h4>
                <div>
                  <p>● 建设产业链数字化生态协同平台</p>
                  <p>● 探索跨企业、跨产业、跨界合作新模式</p>
                </div>
              </div>
              <div>
                <div class="step-number" style="display: flex; justify-content: center;align-items: center;">
                  <h4>人力成本 <br/>下降10-30%</h4>
                  <img :src="require('./assets/img/solution2.png')" style="margin-left: 30px">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="partners">
      <div style="display: flex;flex-direction:column;align-items: center;">
        <h2 class="section-title">合作伙伴</h2>
      </div>
      <div class="container">
        <div class="partner-logos">
          <div class="partner-logo"><img src="./assets/img/partner1.png" alt="中国移动"></div>
          <div class="partner-logo"><img src="./assets/img/partner2.png" alt="中国石油"></div>
          <div class="partner-logo"><img src="./assets/img/partner3.png" alt="中国银行"></div>
          <div class="partner-logo"><img src="./assets/img/partner4.png" alt="中国电信"></div>
          <div class="partner-logo"><img src="./assets/img/partner5.png" alt="清华大学"></div>
          <div class="partner-logo"><img src="./assets/img/partner6.png" alt="北京大学"></div>
          <div class="partner-logo"><img src="./assets/img/partner7.png" alt="浙江大学"></div>
          <div class="partner-logo"><img src="./assets/img/partner8.png" alt="四川大学"></div>
          <div class="partner-logo"><img src="./assets/img/partner9.png" alt="华为"></div>
          <div class="partner-logo"><img src="./assets/img/partner10.png" alt="阿里巴巴"></div>
          <div class="partner-logo"><img src="./assets/img/partner11.png" alt="阿里巴巴"></div>
          <div class="partner-logo"><img src="./assets/img/partner12.png" alt="阿里巴巴"></div>
          <div class="partner-logo"><img src="./assets/img/partner13.png" alt="阿里巴巴"></div>
          <div class="partner-logo"><img src="./assets/img/partner14.png" alt="阿里巴巴"></div>
          <div class="partner-logo"><img src="./assets/img/partner15.png" alt="阿里巴巴"></div>
        </div>
      </div>
    </section>
    <FooterVue style="margin-top: 0"></FooterVue>
  </div>

</template>

<script>
import HeadVue from "../common/HeadVue.vue";
import FooterVue from "../common/FooterVue.vue";
import Carousel from './component/Carousel/index.vue'
export default {
  metaInfo: {
    title: '滁州人工智能-明晟智能科技有限公司',
    meta: [
      { name: 'description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:type', content: 'webpage' },
      { property: 'og:title', content: '滁州人工智能-明晟智能科技有限公司' },
      { property: 'og:description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:url', content: 'https://minsun-ai.com/' },
      { name: 'Keywords',content: "明晟智能科技有限公司,明晟,明晟智能,滁州人工智能,人工智能,AI,明晟大模型,明晟工业大模型"}
    ]
  },
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  components: {
    HeadVue,
    FooterVue,
    Carousel
  },
  data() {
    return {
      carouselItems: [
        {
          image: 'https://picsum.photos/id/1018/800/400',
          title: '美丽的山脉',
          description: '壮观的自然风景'
        },
        {
          image: 'https://picsum.photos/id/1015/800/400',
          title: '河流与森林',
          description: '宁静的自然环境'
        },
        {
          image: 'https://picsum.photos/id/1019/800/400',
          title: '城市景观',
          description: '现代都市风光'
        }
      ]
    }
  },
}
</script>

<style scoped lang="css">
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    body {
      font-family: "Microsoft YaHei", sans-serif;
      color: #333;
    }
    .section-title {
      font-size: 32px;
      color: #181F5C;
      margin-bottom: 20px;
      position: relative;
      text-align: center;
      font-family: "Alimama ShuHeiTi-Bold";
    }
    .section-title:before{
      left: -135px !important;
    }
    .section-title:after{
      right: -135px !important;
    }
    .section-desc{
      font-size: 22px;
      color: #333333;
    }
    .home{
      background-color: #ECF3FF;
    }
    .container {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 15px;
    }
    header {
      background-color: #fff;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      padding: 15px 0;
      position: fixed;
      width: 100%;
      top: 0;
      z-index: 100;
    }

    .logo img {
      height: 40px;
    }
    .nav-menu a {
      margin-left: 20px;
      text-decoration: none;
      color: #333;
      font-size: 14px;
    }
    .banner {
      //height: 500px;
      //background-image:  url("./assets/img/home-banner.png");
      //background-repeat: no-repeat;
      //background-position: center;
      //background-size: cover;
      //padding: 120px 0 80px;
      //text-align: center;
    }
    .banner-inner1, .banner-inner2, .banner-inner3 {
      width: 100%;
      margin: 0 auto;
      //height: 440px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 500px;
      //padding: 120px 0 80px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .banner-inner1 {
      background-image:  url("./assets/img/home-banner.png");
    }
    .banner-inner2 {
      background-image:  url("./assets/img/banner2.png");
    }
    .banner-inner3 {
      background-image:  url("./assets/img/banner3.png");
    }
    .banner-inner-title{
      background: linear-gradient(75deg, #0767FC  0%, #16ED8C 100%);
      width: 367px;
      height: 56px;
      overflow-wrap: break-word;
      /* color: ; */
      font-size: 50px;
      font-family: Alimama ShuHeiTi-Bold;
      font-weight: 700;
      text-align: left;
      white-space: nowrap;
      line-height: 56px;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .banner-inner-desc{
      font-size: 22px;
      color: #333333;
    }


    .inner-content {

    }

    .banner .container{

    }
    .banner h1 {
      font-size: 36px;
      color: #0052d9;
      margin-bottom: 10px;
    }
    .banner p {
      font-size: 16px;
      color: #666;
      margin-bottom: 30px;
    }
    .banner-img {
      max-width: 100%;
      margin-top: 30px;
    }
    .section {
      padding: 60px 0 0 0;
      text-align: center;
    }
    .section-title:before {
      content: "";
      background-image: url('assets/img/title-icon-left.png');
      position: absolute;
      width: 112px;
      height: 59px;
      //background-color: #0052d9;
      bottom: -10px;
      left: 185px;
      //transform: translateX(-50%);
    }
    .section-title:after {
      content: "";
      background-image: url('assets/img/title-icon-right.png');
      position: absolute;
      width: 112px;
      height: 59px;
      //background-color: #0052d9;
      bottom: -10px;
      right: 185px;
      //transform: translateX(-50%);
    }
    .architecture-diagram {
      display: flex;
      justify-content: space-around;
      width: 1020px;
      margin: 40px auto;
      position: relative;
    }
    .diagram-title{
      //font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
      //font-weight: 600;
      font-size: 32px;
      color: #333333;
    }
    .diagram-left-top {
      position: absolute;
      top: 86px;
      left: 172px;
      transform: rotateX(46deg) rotateY(33deg);
    }
    .diagram-left-bottom{
      position: absolute;
      bottom: 115px;
      left: 160px;
      transform: rotateX(46deg) rotateY(-33deg)
    }
    .diagram-left-bottom .line{
      width: 261px;
      height: 2px;
      background: #0767FC;
      margin-top: 20px;
    }
    .diagram-left-top .line{
      width: 234px;
      height: 2px;
      background: #0767FC;
      margin-top: 20px;
    }
    .diagram-right-bottom{
      position: absolute;
      bottom: 80px;
      right: 127px;
      transform: rotateX(46deg) rotateY(33deg)
    }
    .diagram-right-bottom .line{
      width: 334px;
      height: 2px;
      background: #0767FC;
      margin-top: 20px;
    }
    .diagram-left{
      //margin-right: 200px;
    }
    .diagram-right{
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
    .features-grid {
      display: flex;
      justify-content: center;
      margin-top: 40px;
    }
    .features-grid-left{
      //display: grid;
      //grid-template-columns: repeat(1, 1fr);
      //gap: 20px;
    }
    .features-grid-right{
      //display: grid;
      //grid-template-columns: repeat(1, 1fr);
      //gap: 20px;
    }
    .feature-box {
      margin-bottom: 60px;
    }
    .feature-box h3{
      font-weight: 700;
      font-size: 24px;
      color: #181F5C;
      font-family: "Alimama ShuHeiTi-Bold";
      margin-bottom: 10px;
      text-align: left;
    }
    .feature-box p {
      width: 366px;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      text-align: justify;

    }
    .data-platform {
      margin: 50px 0;
    }
    .platform-right-title{
      font-weight: 700;
      font-size: 32px;
      color: #00C240;
      font-family: "Alimama ShuHeiTi-Bold";
    }
    .solution-steps {
      //margin: 50px 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .solution-step {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      width: 800px;
    }
    .step-number {
      //margin-bottom: 20px;
      padding-left: 80px;
    }
    .step-number h4{
      font-weight: 700;
      font-size: 22px;
      color: #181F5C;
      font-family: "Alimama ShuHeiTi-Bold";
    }
    .step-content{
      //margin-bottom: 50px;
    }
    .step-content h4 {
      font-weight: 700;
      font-size: 22px;
      color: #181F5C;
      margin-bottom: 10px;
      font-family: "Alimama ShuHeiTi-Bold";
    }
    .step-content p {
      font-weight: 400;
      font-size: 20px;
      color: #333333;
    }
    .partners {

      padding: 60px 0;
    }
    .partner-logos {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 20px;
      margin-top: 40px;
    }
    .partner-logo {
      background: linear-gradient( 180deg, #ECF1F9 0%, #FEFEFF 100%);
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #FFFFFF;
      padding: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 3px 10px rgba(0,0,0,0.05);
    }
    .partner-logo img {
      max-width: 100%;
      max-height: 50px;
    }
    footer {
      background-color: #0052d9;
      color: white;
      padding: 40px 0;
    }
    .footer-container {
      display: flex;
      justify-content: space-between;
    }
    .footer-column {
      flex: 1;
      padding: 0 15px;
    }
    .footer-column h3 {
      font-size: 18px;
      margin-bottom: 20px;
    }
    .footer-column p, .footer-column a {
      color: rgba(255,255,255,0.8);
      font-size: 14px;
      line-height: 1.8;
      display: block;
      text-decoration: none;
    }
    .qrcode img {
      width: 100px;
      margin-top: 10px;
    }

</style>
